import { render, staticRenderFns } from "./hfdetail.vue?vue&type=template&id=01d6d0e2&scoped=true&"
import script from "./hfdetail.vue?vue&type=script&lang=js&"
export * from "./hfdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d6d0e2",
  null
  
)

export default component.exports